module.exports = __webpack_public_path__ + "img/pasture_buffel_middle.2c5a1456.webp";